import { jsx } from "react/jsx-runtime";
import { Component } from "../coreComponents/Component.js";
import { Field } from "../coreComponents/Field.js";
const SugaredField = Component((props) => {
  if (typeof props.field === "string") {
    return /* @__PURE__ */ jsx(Field, { ...props, field: props.field });
  }
  return /* @__PURE__ */ jsx(Field, { ...props, ...props.field });
}, "SugaredField");
export {
  SugaredField
};
//# sourceMappingURL=SugaredField.js.map
